import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Dispatch, SetStateAction, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { protectedResources } from '../../authConfig';
import { LabContext } from "../../components/PvsContextProvider";
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { useNotificationAPI } from '../../components/NotificationProvider';

interface AcceptLabInvitesProps {
    labInvites: any[],
    setLabInvites: Dispatch<SetStateAction<any[]>>,
    closeWindow: Function,
    children?: React.ReactNode
}

const pageTitle = 'Accept Lab Intive';

const AcceptLabInvites = (props: AcceptLabInvitesProps) => {

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });
    const navigate = useNavigate();
    const labContext = useContext(LabContext);
    const { addNotification } = useNotificationAPI();

    const handleLabInvite = (acceptOrRefuse: string, labId: number) => {
        execute('POST', protectedResources.apiLabInvite.endpoint + acceptOrRefuse, { Id: labId }).then((data: any) => {
            if (!data?.hasNotifications) {
                if (acceptOrRefuse === "DeclineLabInvite") {
                    addNotification('Invite Declined', pageTitle, 'success');
                } else {
                    addNotification('Invite Accepted', pageTitle, 'success');
                    labContext.refresh().then(() => {
                        navigate('/home');
                    });
                }
                if (props.labInvites.length === 1) {
                    props.setLabInvites([]);
                    props.closeWindow();
                } else {
                    const index = props.labInvites.findIndex((invite) => invite.labId === labId);
                    props.labInvites.splice(index, 1);
                    props.setLabInvites(props.labInvites);
                }
            }
        });
    };

    const AcceptInviteCell = (item: any) => {
        const buttonClick = () => {
            handleLabInvite("AcceptLabInvite", item.dataItem.labId);
        }

        return <td>
            <Button onClick={buttonClick}>Accept</Button>
        </td>
    };

    const DeclineInviteCell = (item : any) => {
        const buttonClick = () => {
            handleLabInvite("DeclineLabInvite", item.dataItem.labId);
        }
        
        return <td>
            <Button onClick={buttonClick}>Decline</Button>
        </td>
    };
    
    return (
        <>
            <Grid
                data={props.labInvites}>
                <GridColumn field="facilityName" title="Lab"/>
                <GridColumn width="100px" cell={AcceptInviteCell} title="Accept"/>
                <GridColumn width="100px" cell={DeclineInviteCell} title="Decline"/>
            </Grid>
        </>
    );
}

export default AcceptLabInvites;